/*
 * Lib Module Maps
 */

Lib.Map = (function() {

    var self = {};

    var mapsIsInitialized = false;

    $(Lib).on('document.ready', function() {
        var maps = $('[data-map]');
        if (maps.length) {
            self.getGoogleMapsAPI();
        }
    });

    self.getGoogleMapsAPI = function() {

        if (mapsIsInitialized) {
            self.mapsCallback();
            return;
        }

        var jsApiKey = Lib.Util.getOption('data.maps_api_key');
        if (jsApiKey !== null) {
            $.getScript('https://maps.google.com/maps/api/js?key=' + jsApiKey + '&language=nl&callback=Lib.Map.mapsCallback');
        } else {
            Lib.Debug.warn('No Google Maps API key found in Lib options, provide Lib.options.data.maps_api_key');
        }
    };

    self.mapsCallback = function() {
        mapsIsInitialized = true;
        self.initializeMaps($('[data-map]:not([data-has-map])'));
        self.initializeStreetviews($('[data-streetview]:not([data-has-streetview])'));
    };

    /**
     *
     * @param mapElements
     */
    self.initializeMaps = function(mapElements) {

        mapElements.each(function() {

            var mapContainer = $(this);

            mapContainer.attr('data-has-map', true);

            var mapOptions = $.extend(true, {
                lat: 52.18, lng: 5.56, zoom: 7, maxZoom: 17, panControl: true, zoomControl: true, scaleControl: false, streetViewControl: 0, marker: false, navigationControl: false, mapTypeControl: false, draggable: true
            }, mapContainer.data('map'));

            var mapInstance = new google.maps.Map(mapContainer[0], {
                streetViewControl: mapOptions.streetViewControl, mapTypeControl: mapOptions.mapTypeControl, navigationControl: mapOptions.navigationControl, center: new google.maps.LatLng(parseFloat(mapOptions.lat), parseFloat(mapOptions.lng)), zoom: mapOptions.zoom, maxZoom: mapOptions.maxZoom, mapTypeId: google.maps.MapTypeId.ROADMAP, panControl: mapOptions.panControl, zoomControl: mapOptions.zoomControl, scaleControl: mapOptions.scaleControl, draggable: mapOptions.draggable
            });

            mapContainer.fadeIn(200);

            if (mapOptions.marker) {
                self.makeMarker(mapInstance, mapOptions.marker, mapContainer);
            }

        });

    };

    /**
     *
     * @param streetviewElements
     */
    self.initializeStreetviews = function(streetviewElements) {

        streetviewElements.each(function() {

            var streetviewContainer = $(this);

            streetviewContainer.data('allow-streetview-update', true);

            let streetviewOptions = $(this).data('streetview');
            if (!('address' in streetviewOptions) && !('addressFields' in streetviewOptions) && !('addressField' in streetviewOptions)) {
                Lib.Debug.warn('No streetview.address or streetview.addressFields set');
                return;
            }

            let width = streetviewOptions.width || 500;
            let height = streetviewOptions.height || 300;

            streetviewContainer.attr('data-has-streetview', true);

            streetviewContainer.on('streetview.update', function() {

                if ($(this).data('allow-streetview-update') === false) {
                    return;
                }

                let address = streetviewOptions.address || self._getStreetviewAddress(streetviewOptions);

                if (!address) {
                    return;
                }

                let streetviewSource = `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${encodeURIComponent(address)}&key=${Lib.Util.getOption('data.maps_api_key')}`;

                streetviewContainer.find('img').remove();

                streetviewContainer.append(Lib.Element.spawn('img', {
                    src: streetviewSource,
                    alt: `Streetview ${address}`
                }));

            });

            streetviewContainer.on('streetview.notice', function(e, data) {

                $(this).find('span.streetview-notice').remove();

                streetviewContainer.append(Lib.Element.spawn('span', {'class': 'streetview-notice'}));
                $(this).find('span.streetview-notice').text(data.notice);

            });

            streetviewContainer.trigger('streetview.update');

        });

    };

    /**
     *
     * @param streetviewOptions
     * @private
     */
    self._getStreetviewAddress = function(streetviewOptions) {

        if (streetviewOptions.addressField) {
            return $(streetviewOptions.addressField).val();
        }

        let address = ``;
        $(streetviewOptions.addressFields.join(',')).each(function() {
            address += `${$(this).val()} `;
        });

        return address.trim();
    };

    self.makeMarker = function(map, options_, mapContainer) {

        var options = $.extend(true, {
            latField: false, lngField: false, showOnInit: false, icon: '', lat: 52.18, lng: 5.56
        }, options_);

        if (!options.showOnInit) {
            mapContainer.addClass('inactive-overlay');
        }

        if (options.lat !== '' && options.lng !== '' && options.lat !== null && options.lng !== null) {

            var markerOptions = {
                draggable: true, map: (options.showOnInit) ? map : null, position: new google.maps.LatLng(parseFloat(options.lat), parseFloat(options.lng))
            };

            if (!options.latField || !options.lngField) {
                markerOptions.draggable = false;
            }

            var marker = new google.maps.Marker(markerOptions);

            if (options.showOnInit) {
                map.panTo(marker.position);
                map.setZoom(15);
            }
            if (markerOptions.draggable) {

                var elLatfield = $(options.latField);
                var elLngfield = $(options.lngField);

                if (elLatfield.length && elLngfield.length) {

                    google.maps.event.addListener(marker, 'dragend', function() {
                        var pos = marker.getPosition();
                        elLatfield.val(pos.lat());
                        elLngfield.val(pos.lng());
                        mapContainer.removeClass('inactive-overlay');
                    });

                    mapContainer.on('mapnotice.show, marker.position, marker.pan, marker.zoom, marker.hide, marker.update', function() {
                        mapContainer.removeClass('inactive-overlay');
                    });

                    mapContainer.on('mapnotice.show', function() {

                        if (mapContainer.parent().find('.map-notice').length === 0) {
                            $('<div />').addClass('map-notice m-t-15').text('De positie op de kaart is automatisch bepaald. Indien deze niet juist is, kun je de marker verslepen naar de juiste locatie.')
                            .appendTo(mapContainer.parent());
                        }
                    });

                    mapContainer.on('marker.position', function(e, lat, lng) {

                        var latlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
                        marker.setPosition(latlng);
                        marker.setMap(map);
                        mapContainer.trigger('marker.pan');
                        mapContainer.trigger('marker.zoom', [15]);
                        mapContainer.trigger('mapnotice.show');
                    });

                    mapContainer.on('marker.update', function() {
                        mapContainer.trigger('marker.position', [elLatfield.val(), elLngfield.val()]);
                    });

                    mapContainer.on('marker.show', function() {
                        marker.setMap(map);
                    });

                    mapContainer.on('marker.hide', function() {

                        marker.setMap(null);
                    });

                    mapContainer.on('marker.pan', function() {

                        map.panTo(marker.position);
                    });

                    mapContainer.on('marker.zoom', function(e, zoom) {

                        if (typeof zoom === 'undefined') {
                            zoom = 15;
                        }
                        map.setZoom(zoom);
                        map.panTo(marker.position);
                    });

                    if (elLatfield.val() !== '' && elLngfield.val() !== '') {
                        mapContainer.trigger('marker.update');
                    }
                }
            }

            return marker;
        } else {
            mapContainer.addClass('inactive-overlay');
        }
    };

    return self;

})();
